import { Component, signal, Input, Output, EventEmitter, input, OnInit } from '@angular/core';


@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrl: './select.component.css',
  standalone: false
})
export class SelectComponent implements OnInit {

  _list = signal<SelectListItem[]>([]);
  _value = signal(null);
  _block = signal(true);
  _placeholder = signal(null);
  _caption = signal<string>(null);
  model: any = '';

  selectFirst = input<boolean>(false);

  @Input()
  public set list(v: SelectListItem[]) {
    this._list.set(v);
  }

  @Input()
  public set value(v: any) {
    this._value.set(v);
    this.model = v;
  }

  @Input()
  public set block(v: boolean) {
    this._block.set(v);
  }

  @Input()
  public set placeholder(v: string) {
    this._placeholder.set(v);
  }

  @Input()
  public set caption(v: string) {
    this._caption.set(v);
  }

  @Output()
  onSelected: EventEmitter<any> = new EventEmitter();

  ngOnInit(): void {
    if (this.selectFirst()) {
      this.model = this._list()[0]?.id;
    }
  }

  changed() {
    console.log(`changed`, this.model);
    this.onSelected.emit(this.model);
  }
}

export interface SelectListItem {
  id: number | string;
  title: string;
}
